// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableAfterPaint, LoadablePaint } from '@confluence/loadable';

export const LazyTeamCalendars = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TeamCalendars" */ './TeamCalendars')).TeamCalendar,
});

export const LazyHomepageCard = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HomepageCard" */ './HomepageCard')).HomepageCard,
});

export const LazyTeamCalendarSiteSettingsPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TeamCalendarSiteSettingsPage" */ './site-settings/TeamCalendarSiteSettingsPage'
			)
		).TeamCalendarSiteSettingsPage,
});

export { ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE } from '../src/site-settings/teamCalendarSiteSettingsConstants';
export { CALENDAR_CONTEXT } from './components/TeamCalendarContextProvider';
